import { camelToKebabCase } from '@lemonade-hq/ts-helpers';
import { css } from 'styled-components';
import { supportsCssVariables } from './styles.esm.js';

/* eslint-disable @typescript-eslint/dot-notation */ // FONTS
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    font-family: var(--",
        "-font-family);\n    ",
        "\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function font(fontType) {
    var fontProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fontKeys = [
        "fontSize",
        "lineHeight",
        "fontWeight"
    ];
    var _fontProps_fontKey;
    return css(_templateObject(), camelToKebabCase(fontType), fontKeys.map(function(fontKey) {
        return "".concat(camelToKebabCase(fontKey), ": ").concat((_fontProps_fontKey = fontProps[fontKey]) !== null && _fontProps_fontKey !== void 0 ? _fontProps_fontKey : getCssVar("".concat(fontType, "-").concat(fontKey)), ";");
    }));
}
// SUPPORTS CSS-VARS
function createCssVar(name, value) {
    return "--".concat(camelToKebabCase(name), ": ").concat(value, ";");
}
function getCssVar(name) {
    return "var(--".concat(camelToKebabCase(name), ")");
}
function fontObjectToCssVar(fontType, fontProps) {
    return Object.entries(fontProps).map(function(param) {
        var _param = _sliced_to_array(param, 2), fontKey = _param[0], fontValue = _param[1];
        return createCssVar("".concat(fontType, "-").concat(fontKey), fontValue);
    }).join("");
}
function color(colorName) {
    return function() {
        return getCssVar("".concat(colorName, "-color"));
    };
}
function themedColor(colorName) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return function(param) {
        var theme = param.theme;
        return supportsCssVariables() ? getCssVar("".concat(colorName, "-color")) : theme.colors[colorName];
    };
}
/**
 * Extracts the CSS properties from the typography variant config and converts them to
 * a Styled Components style object. Later to be applied to the Text component.
 */ var convertToVariantValue = function(variants) {
    return Object.fromEntries(Object.entries(variants).map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], _param1 = _param[1];
        var cssProps = _param1.cssProps, rest = _object_without_properties(_param1, [
            "cssProps"
        ]);
        return [
            key,
            _object_spread({
                cssProps: css(cssProps)
            }, rest)
        ];
    }));
};

export { color, convertToVariantValue, createCssVar, font, fontObjectToCssVar, getCssVar, themedColor };
